import { render, staticRenderFns } from "./RelativesInfoEdit.vue?vue&type=template&id=31bc97d3&scoped=true&"
import script from "./RelativesInfoEdit.vue?vue&type=script&lang=js&"
export * from "./RelativesInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./RelativesInfoEdit.vue?vue&type=style&index=0&id=31bc97d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc97d3",
  null
  
)

export default component.exports